import React from 'react'

export default function TitleBar({slimmer, action}) {
  return <div className='titlebar'>
    <div className='name'>{slimmer.name}</div>
    {action}
  </div>}
